import React from 'react';
import FormROValue from '../../../library/form/components/FormROValue1';
import FormROChipValue from '../../../library/form/components/FormROChipValue';
import DocCardContainer from '../../cmn/DocCardContainer';
import { Icon as SarasIcon } from '../../../library/decor/SarasIcons';

const ProContactRow = (props) => {
const { formObject, rowKey } = props;

return (
<DocCardContainer formObject={formObject} rowKey={rowKey}>
<div>
<div className="uiCardHeader uiRowHeight1">
<FormROValue
format="#"
formObject={formObject}
rowKey={rowKey}
action={{ paramName: "fullName" }}
id="svFullName"
className="uiCardTitle"
/>
<FormROChipValue
format="#"
formObject={formObject}
rowKey={rowKey}
action={{ paramName: "conType" }}
id="svConType"
className=""
hideIfEmpty={true}
/>
</div>
      <div className="uiCardBodyGrid">
        <div className="uiCardColLeft">
          <FormROChipValue
            format="#"
            formObject={formObject}
            rowKey={rowKey}
            hideIfEmpty={true}
            action={{ paramName: "mobile1" }}
            id="svMobile1"
            icon={<SarasIcon.mobile />}
            className="uiChip--mobile"
            linkType="tel"
            copyOnClick={true}
          />
          <FormROChipValue
            format="#"
            formObject={formObject}
            rowKey={rowKey}
            hideIfEmpty={true}
            action={{ paramName: "whatsApp" }}
            id="svWhatsApp"
            icon={<SarasIcon.whatsapp />}
            className="uiChip--whatsapp"
            linkType="wa"
            copyOnClick={true}
          />
          <FormROChipValue
            format="#"
            formObject={formObject}
            rowKey={rowKey}
            hideIfEmpty={true}
            action={{ paramName: "mobile2" }}
            id="svMobile2"
            icon={<SarasIcon.mobile />}
            className="uiChip--mobile"
            linkType="tel"
            copyOnClick={true}
          />
          <FormROChipValue
            format="#"
            formObject={formObject}
            rowKey={rowKey}
            hideIfEmpty={true}
            action={{ paramName: "landline1" }}
            id="svLandline1"
            icon={<SarasIcon.landline />}
            className="uiChip--landline"
            linkType="tel"
            copyOnClick={true}
          />
          <FormROChipValue
            format="#"
            formObject={formObject}
            rowKey={rowKey}
            hideIfEmpty={true}
            action={{ paramName: "landline2" }}
            id="svLandline2"
            icon={<SarasIcon.landline />}
            className="uiChip--landline"
            linkType="tel"
            copyOnClick={true}
          />
        </div>

        <div className="uiCardColRight">
          <FormROChipValue
            format="#"
            formObject={formObject}
            rowKey={rowKey}
            hideIfEmpty={true}
            action={{ paramName: "email1" }}
            id="svEmail1"
            icon={<SarasIcon.email />}
            className="uiChip--email"
            linkType="mailto"
            copyOnClick={true}
          />
          <FormROChipValue
            format="#"
            formObject={formObject}
            rowKey={rowKey}
            hideIfEmpty={true}
            action={{ paramName: "email2" }}
            id="svEmail2"
            icon={<SarasIcon.email />}
            className="uiChip--email"
            linkType="mailto"
            copyOnClick={true}
          />
        </div>
      </div>

      <div className="uiContactRemarks uiRowHeight1">
        <FormROValue
          format="#"
          formObject={formObject}
          rowKey={rowKey}
          action={{ paramName: "remarks" }}
          id="svRemarks"
        />
      </div>
    </div>
  </DocCardContainer>

);
};

export default ProContactRow;
